<template>
  <div class="wraper">
    <el-row class='top'>
      <span>自定义报表</span>
      <el-tooltip placement="right">
        <div slot="content">
            自定义报表：以分组为维度，把不同渠道、大区、省区/分公司、冷柜系列、渠道类型、二级渠道、三级渠道、
          <br>经销商、客户类型、网点、省份、城市、投放政策下的设备放入同一分组，统一查看管理。
          <br>累计客流：分组内所有大数据冷柜客流量总和(开关门次数-补货次数)
          <br>平均日客流：分组内平均每台设备每天客流量
          <br>平均纯净度：分组内所有大数据冷柜纯净度平均值
          <br>累计销售额：分组内所有大数据冷柜销售额量总和(排除补货、退货状态后，各商品销售数量*对应单价后金额总和)
          <br>平均销售额：分组内平均每台设备每天额销售额
          <br>累计销量：分组内所有大数据冷柜销量总和(排除补货、退货状态后，各商品销售数量总和）
          <br> 平均销量：分组内平均每台设备每天的销售额
        </div>
        <i class="el-icon-question"></i>
      </el-tooltip>
      <el-date-picker
        size='mini'
        v-model="date"
        type="daterange"
        align="right"
        unlink-panels
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :clearable='clearDate'
        :picker-options="pickerOptions"
      >
      </el-date-picker>
      <el-button size="mini" type="primary" @click='search'>查询</el-button>
      <div class="export_btn">
        <exporter
          :setting='setting'
          :url='getListUrl'
          :date='date'
          :exportName="exportName"
        ></exporter>
      </div>
    </el-row>
    <!-- <deviceSearchBox @getSearchSelect="searchTable"></deviceSearchBox> -->
    <el-row>
      <report
        :setting='setting'
        :list='list'
        :date='date'
        @changeSort="handleSun"
      ></report>
      <el-row class="pages">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </el-row>
  </div>
</template>

<script>
    import Report from '../../components/Report'
    import exporter from '../../components/exporter'
    import deviceSearchBox from '../devices/components/deviceSearchBox'

    export default {
        name: 'reports',
        components: {
            Report,
            exporter,
            deviceSearchBox
        },
        data() {
            return {
                exportName:'分组报表',
                getListUrl: 'data/getDataReport_GroupList',
                date: this.getDefaultDay(),
                clearDate: false,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - (1000 * 60 * 60 * 24);
                    },
                    shortcuts: [{
                        text: '昨天',
                        onClick(picker) {
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', [start, start]);
                        }
                    }, {
                        text: '最近七天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                currentPage: 1,
                setting: {
                    isShowSelect: false,
                    isShowIndex: false,
                    tHeader: [{
                        dataItem: 'groupName',
                        dataName: '分组名称',
                        width: '130px'
                    }, {
                        dataItem: 'putAssetsNum',
                        dataName: '投放设备数量',
                        width: '130px'
                    }, {
                        dataItem: 'sumCustomerFlow',
                        dataName: '累计客流（台）',
                        width: '150px'
                    }, {
                        dataItem: 'avgCustomerFlow',
                        dataName: '平均客流（台）',
                        width: '150px'
                    }, {
                        dataItem: 'avgPurity',
                        dataName: '平均专放率 （%）',
                        width: '180px'
                    }, {
                        dataItem: 'sumSalesNum',
                        dataName: '累计销量（台）',
                        width: '180px'
                    }, {
                        dataItem: 'avgSalesNum',
                        dataName: '平均销量（台）',
                        width: '150px'
                    }, {
                        dataItem: 'sumSalesAmount',
                        dataName: '累计销售额（台）',
                        width: '180px'
                    }, {
                        dataItem: 'avgSalesAmount',
                        dataName: '平均销售额（台）',
                        width: '180px'
                    }],
                    isShowPlay: true,
                    isShowDelBtn: false,
                    isShowEditBtn: false,
                    isShowInfoBtn: true,
                    btnsWidth: '250px',
                    infoUrl: 'reportsDetail'
                },
                list: [],
                total: 0,
                pageSize: 10
            }
        },
        mounted() {
            this.getList()
        },
        methods: {
            getDefaultDay() {
                let date = new Date();
                let startdate = new Date(date.getTime() - 1000 * 60 * 60 * 24 * 8);
                let startyear = startdate.getFullYear();
                let startmonth = startdate.getMonth() + 1;
                if (startmonth < 10) {
                    startmonth = "0" + startmonth;
                }
                let startday = startdate.getDate();
                if (startday < 10) {
                    startday = "0" + startday;
                }
                startdate = startyear + '-' + startmonth + '-' + startday;
                let enddate = new Date(date.getTime() - 1000 * 60 * 60 * 24);
                let endyear = enddate.getFullYear();
                let endmonth = enddate.getMonth() + 1;
                if (endmonth < 10) {
                    endmonth = "0" + endmonth;
                }
                let endday = enddate.getDate();
                if (endday < 10) {
                    endday = "0" + endday;
                }
                enddate = endyear + '-' + endmonth + '-' + endday;
                return [startdate, enddate];
            },
            searchTable() {

            },
            getList(val) {
                let url = this.getListUrl;
                let params = {
                    startDay: this.date[0],
                    endDay: this.date[1],
                    pageSize: this.pageSize,
                    pageNum: this.currentPage
                }
                if(val!=undefined){
                    params.order = val.order;
                    params.prop  =  val.prop;
                }
                let _this = this;
                this.$ajax.post(url, params)
                    .then(this.getListSucc)
                    .catch(function (res) {
                        _this.$message.error('哎呀~网络异常了呢');
                    })
            },
            getListSucc(res) {
                if (res.data && res.data.code === 200) {

                    const data = res.data.data;
                    this.list = data.list;
                    this.total = data.total;
                } else {
                    let errMsg = '未知错误'
                    if (res.data.msg) {
                        errMsg = res.data.msg;
                    }
                    this.$message.error(errMsg);
                }
            },
            search() {
                this.getList();
            },
            handleSizeChange(val) {
                // console.log('每页 '+val+' 条');
                this.pageSize = val;
                this.currentPage = 1;
                this.getList()
                // console.log(this.pageSize);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getList()
            },
            handleSun(val) {
                this.getList(val)
            }
        }
    }
</script>
<style scoped>
  .top {
    height: 50px;
  }

  .pages {
    padding-top: 10px;
    text-align: center;
   
  }
</style>



// WEBPACK FOOTER //
// src/pages/reports/reports.vue